import {useSelector} from "react-redux";

import {Container} from "@bounce/shared/ui";
import {AppState} from "../store/definitions";
import {NotificationBarItem} from "./NotificationBarItem";

export const NotificationBar = () => {
  const notifications = useSelector((store: AppState) => store.notifications);

  return (
    <Container sx={{position: "relative", gap: 0}}>
      <Container sx={{position: "absolute", width: "100%", overflow: "hidden", zIndex: 10, gap: 0}}>
        {notifications.map((notification) => (
          <NotificationBarItem key={notification.id} {...notification} />
        ))}
      </Container>
    </Container>
  );
};
